import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GoPassPortal from "./pages/GoPassPortal";
import PagoExitoso from "./pages/PagoExitoso";
import PagoCancelado from "./pages/PagoCancelado";
import "./App.css";

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path="/" element={<GoPassPortal />} />
        <Route path="/finalizado/:id" element={<PagoExitoso />} />
        <Route path="/cancelado/:id" element={<PagoCancelado />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
